import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { Checkbox } from '@johnlewispartnership/wtr-ingredients/ingredients/Checkbox';
import { LabeledControl } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/LabeledControl';
import RichText from '../../../../components/RichText';
import analyticsPropType from '../../../../constants/data-shapes/analytics';
import cqResponsivePropType from '../../../../constants/data-shapes/cq-responsive';
import { richTextNode } from '../../../../constants/types/rich-text';
import styles from '../../CompetitionsForm.module.scss';
const OptInSection = ({ form: { register }, optIns, singleClickEntry }) => (React.createElement(React.Fragment, null,
    optIns && (React.createElement("div", { id: "rich-text-wrapper", className: classNames({
            [styles.richTextSpacing]: !singleClickEntry && optIns.introText,
        }) },
        React.createElement(RichText, Object.assign({}, optIns.introText, { locationName: "CompetitionForm-OptIn", position: "competitions-1" })))),
    optIns && (React.createElement("div", { className: classNames(styles.optInWrapper, styles.spacer, {
            [styles.oneClickHighlighted]: singleClickEntry,
        }) }, optIns.optInList.map(({ optInName, optInDescription }, index) => (React.createElement(LabeledControl, { key: optInName, control: React.createElement(Checkbox, { name: `optIns[${index}]`, ref: register, value: optInName }), label: optInDescription })))))));
OptInSection.propTypes = {
    form: propTypes.shape({
        errors: propTypes.objectOf(propTypes.shape({
            ref: propTypes.shape({ scrollIntoView: propTypes.func, focus: propTypes.func }),
            type: propTypes.string,
            message: propTypes.string,
        })),
        register: propTypes.func.isRequired,
    }).isRequired,
    optIns: propTypes.shape({
        introText: propTypes.shape({
            data: propTypes.shape({
                analytics: analyticsPropType(),
                blocks: propTypes.arrayOf(richTextNode),
                componentId: propTypes.string,
                cqResponsive: cqResponsivePropType(),
                noMargin: propTypes.bool,
                styleIds: propTypes.arrayOf(propTypes.string),
                valid: propTypes.bool,
            }),
            locationName: propTypes.string,
        }),
        optInList: propTypes.arrayOf(propTypes.shape({ optInName: propTypes.string, optInDescription: propTypes.string })),
    }),
    singleClickEntry: propTypes.bool,
};
OptInSection.defaultProps = {
    optIns: undefined,
    singleClickEntry: false,
};
export default OptInSection;
//# sourceMappingURL=index.js.map